import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  nartSearchHelperText: {
    lineHeight: "12px",
    marginBottom: "4px",
    fontWeight: 400,
    fontSize: "0.75rem",
    fontFamily: "Proxima Nova",
    color: "rgb(117, 117, 117)",
  },
}));

export default useStyles;
